import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/services/session/session.service';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
    private sessionService: SessionService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('/api/oauth2/v1/token')) {
      return next.handle(request);
    }

    if(request.url.search('FSB_COMUNICACAO') != -1){
      const tenantID = this.sessionService.tenantID;

      if (this.sessionService.isTokenExpired()) {
        return this.sessionService.refreshToken().pipe(
          switchMap(() => {
            const token = this.sessionService.getAccessToken();
            const clonedReq = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`,
                tenantId: tenantID ? tenantID : '01,0101'
              }
            });
            return next.handle(clonedReq);
          })
        );
      } else {
        const token = this.sessionService.getAccessToken();
        const clonedReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantID ? tenantID : '01,0101'
          }
        });
        return next.handle(clonedReq);
      }
    }
  }
}
